import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  userList:any;
  userProfilePic:string;
  closeResult: string;
  imgPlaceholder = './assets/images/noimage.png';
  userID:string;
  

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService:HelperService,
    private modalService: NgbModal) { }

  ngOnInit() {

    this.userID = this.helperService.studented_atob(this.helperService.getToken());
    if(this.userID==""){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`profile`);
    }

    let userData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
     
    }

    this.apiService.userDetails(userData).subscribe((res:any)=>{
      
      this.userList = res.data.getUserData.data;
      

      this.userProfilePic = res.data.getUserData.data.userProfilePic;


  },async err => {
     
  })

  }
  editUser(userID){
    
   this.router.navigateByUrl(`useredit/`+window.btoa(userID)); 
  }

  

  userProfile(){
    this.router.navigateByUrl(`userprofile`);
  }
  
  enrollment(){   
    this.router.navigateByUrl(`enrollment`);
  }
 
  assessment(){
    this.router.navigateByUrl(`assessment`);
  }
  dashboard(){    
    this.router.navigateByUrl(`dashboard`);
  }
  assignment(){
    this.router.navigateByUrl(`assignment`);
  }
  notice(){
    this.router.navigateByUrl(`notice`); 
  }
  enquiry(){
    this.router.navigateByUrl(`enquiry`);
  }
  content(){
    this.router.navigateByUrl(`content`);
  }
  classes(){
    this.router.navigateByUrl(`courses`);
  }
  requirement(){
    
  }

  open(content) {
    this.modalService.open(content, {centered: true}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}
